// extracted by mini-css-extract-plugin
export default {"wrapper":"So","form":"To","circle":"Uo","success":"Vo","button":"Wo"};